import styled from 'styled-components';

import { MediaQuery, Transition } from '../../constants/Styles';

export const MenuWrapper = styled.div`
  margin: 0 75px;
  max-width: 1140px;
  min-width: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const Container = styled.div`
  transition: ${Transition.ALL_EASE};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  pointer-events: none;
  position: fixed;
  top: 0;
  transform: translateY(
    ${({ position }) => (position ? `${position}px` : '420px')}
  );
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  ${MediaQuery.L_AND_DOWN} {
    display: none;
  }
`;
